
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/r/[referral]",
      function () {
        return require("private-next-pages/r/[referral].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/r/[referral]"])
      });
    }
  